import React, { useEffect, useState } from "react";
import Nav from "../components/nav";
import { DatabaseFill, List, Power, Upload } from "react-bootstrap-icons";
import DataTable from 'react-data-table-component';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { onAuthStateChanged, signOut } from "firebase/auth";
import {
  addUserResume,
  auth,
  getUserFromDatabase,
  updateUserResumes,
} from "../fireabse";
import {
  saveResume,
  signOutUser,
  updateResume,
  updateUser,
} from "../redux/slices/user";
import "../styleSheet/Dashboard.css";
import {
  upload,
  Share,
  ThreeDots,
  Check2Circle,
  PencilSquare,
  FileEarmarkArrowDownFill,
  Bullseye,
  PlusLg,
  PencilFill,
  Trash3Fill,
  ColumnsGap,
  Book,
  JournalRichtext,
  BagFill,
  GraphUpArrow,
  MegaphoneFill,
  Alipay,
  Bicycle,
  CheckSquare,
} from "react-bootstrap-icons";
import img1 from "../images/template1.PNG";
import img2 from "../images/template2.PNG";
import img3 from "../images/template3.PNG";
import img4 from "../images/template4.PNG";
import ResumeSelectorModal from "./resumeSelectorModal";
import Templates from "../components/templates";
import JobPopup from "../components/jobPopup";
import { Tooltip } from "react-tooltip";
import axios from 'axios';
import ViewJob from "./ViewJob";

export default function Dashboard() {
  const navigate = useNavigate();
  const [gettingUser, SetGettingUser] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null)
  const [jobApplications, setJobApplications] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [jobSearchTerm, setJobSearchTerm] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}jobs/latest-jobs/`);
        // console.log("response........",response);
        
        setJobs(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    const listen = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // console.log("userFirebase....",user.email);
        SetGettingUser(true);
        const userFirebase = await getUserFromDatabase(user.email);
        dispatch(updateUser(userFirebase));
        initializeSavedResumes(userFirebase);
        SetGettingUser(false);
      } else {
        navigate("/");
      }
    });
  }, [dispatch, navigate]);

  const handleMenu = () => {
    setShowMenu(!showMenu);
  };

  const fetchJobApplications = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}candidate/candidates-without-login-applied/${user.email}/`);
      setJobApplications(response.data.data);
    } catch (error) {
      console.error("Error fetching job applications:", error);
    }
  };
  useEffect(() => {
    if (user && user.email) { // Ensure user is defined
      fetchJobApplications();
    }
  }, [user]);

  const [savedResumes, setSavedResumes] = useState([
    {
      resumeId: 1,
      img: img1,
      title: "My Profile",
      description: "Description",
      id: "id46876548",
      idx: -1,
    },
  ]);
  
  const handler = (e) => {
    signOut(auth)
      .then(() => {
        dispatch(signOutUser());
        navigate("/");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const initializeSavedResumes = (user) => {
    if (user.resumes) {
      var temp = [];
      var srem = {};
      var arr = [];
      // console.log("uset resume..........",user.resumes);
      const currentTimestamp = new Date().toLocaleString();
      for (var i = 0; i < user.resumes.length; i++) {
        var resume = user.resumes[i];
        var tempimg = img1;

        if (resume.resumeId === 2) {
          tempimg = img2;
        } else if (resume.resumeId === 3) {
          tempimg = img3;
        } else if (resume.resumeId === 4) {
          tempimg = img4;
        }
        srem.resumeId = resume.resumeId;
        srem.img = tempimg;
        srem.title = resume.jobTitle;
        srem.description = currentTimestamp;
        // srem.description =  resume.professionalSummary.substring(0, 20);
        srem.id = resume.id;
        srem.idx = i;
        arr = [...arr, srem];
        srem = {};
        // console.log(arr)
      }
      setSavedResumes(arr);
      // user.resumes.map((resume,index)=>{
      //     console.log(resume.resumeId)
      //     var tempimg = img1;

      //     if(resume.resumeId === 2){
      //         tempimg = img2;
      //     }else if(resume.resumeId === 3){
      //         tempimg = img3;
      //     }else if(resume.resumeId === 4){
      //         tempimg = img4;
      //     }
      //     console.log(resume.resumeId)
      //     srem.resumeId = resume.resumeId;
      //     console.log(srem.resumeId)
      //     srem.img = tempimg;
      //     srem.title = resume.jobTitle;
      //     srem.description = resume.professionalSummary.substring(0, 20);
      //     srem.id = resume.id;
      //     srem.idx = index;
      //     console.log(srem)
      //     temp.push(srem);
      //     console.log(temp)
      //     console.log(arr)
      // })
      // console.log(temp)
      // setSavedResumes(temp)
    }
  };

  const addSavedResume = () => {
    var temp = {
      jobTitle: "",
      firstName: "",
      middleName: "",
      lastName: "",
      inputEmail: "",
      phone: "",
      dateOfBirth: "",
      city: "",
      address: "",
      postalCode: "",
      drivingLicense: "",
      nationality: "",
      placeOfBirth: "",
      country: "",
      professionalSummary: "",
      uploadedPhotoURL: "",
      login_email: "",
      employmentHistory: [
        {
          jobTitle: "",
          employer: "",
          startDate: "",
          endDate: "",
          city: "",
          description: "",
        },
      ],
      educationHistory: [
        {
          school: "",
          degree: "",
          startDate: "",
          endDate: "",
          city: "",
          description: "",
        },
      ],
      websitesLinks: [
        {
          name: "",
          url: "",
        },
      ],
    };
    Object.entries(temp).map(([key, value]) => {
      temp[key] = user[key];
    });
    var resume = {
      ...temp,
      skills: [],
      customDetails: {
        courses: [],
        activities: [],
        internships: [],
        hobbies: [],
        languages: [],
        references: [],
        customSections: [],
      },
      resumeId: 1,
      id: "id" + new Date().getTime(),
    };

    var resumes = [...user.resumes, resume];
    const currentTimestamp = new Date().toLocaleString();
    addUserResume(user.email, resumes);
    dispatch(saveResume(resume));
    const newDiv = {
      resumeId: resume.resumeId,
      img: img1,
      title: resume.jobTitle,
      // description :  resume.professionalSummary.substring(0, 20),
      description: currentTimestamp,
      id: resume.id,
      idx: user.resumes.length,
    };
    setSavedResumes([...savedResumes, newDiv]);
  };

  const delSavedResume = async (id) => {
    setDeleting(true);
    const updatedResumes = savedResumes.filter((resumes) => resumes.id !== id);
    const updatedUserResumes = user.resumes.filter(
      (resumes) => resumes.id !== id
    );

    dispatch(updateResume(updatedUserResumes));
    await updateUserResumes(user.email, updatedUserResumes);
    setDeleting(false);
    setSavedResumes(updatedResumes);
  };

  const openSelectedResume = (idx) => {
    if (idx == -1) {
      navigate("/create");
    } else {
      navigate(`/createcontinue/${idx}`);
    }
  };
  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };
  const tailor = (idx) => {
    // setIsPopupOpen(!isPopupOpen);
    navigate(`/createcontinue/${idx}`, { state: { popon: true } });
  };
  const download = (idx) => {
    // setIsPopupOpen(!isPopupOpen);
    navigate(`/createcontinue/${idx}`, { state: { download: true } });
  };
  const handleSignup = () => {
    togglePopup();
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleJobApply = (jobId) => {
    setSelectedJobId(jobId);
    setIsModalOpen(true);
  };

  const handleResumeSelect = async (resumeId) => {
    const savedResume = savedResumes.find(resume => resume.id === resumeId);
    const selectedResume = user.resumes.find(resume => resume.id === resumeId);
  
    if (!selectedResume) return;
  
    try {
      // const liveDomain = 'http://localhost:3002'; 
  
      const formData = {
        job: String(selectedJobId),
        login_email: user.email,
        first_name: selectedResume.firstName || '',
        middle_name: selectedResume.middleName || '',
        last_name: selectedResume.lastName || '',
        mobile: selectedResume.phone || '',
        alternate_mobile: '',
        email: selectedResume.inputEmail || '',
        alternate_email: '',
        gender: '',
        marital_status: '',
        bachlor_degree: '',
        professional_degree: '',
        date_of_birth: selectedResume.dateOfBirth || '',
        age: selectedResume.age || null, // Calculate age if needed
        pincode: selectedResume.postalCode || null,
        state: '', // Map to state ID if available
        country: '', // Map to country ID if available
        city: selectedResume.city || '',
        street: selectedResume.address || '',
        exp_years: null, // Map experience years if available
        highest_qualification: '', // Map highest qualification if available
        current_job_title: selectedResume.jobTitle || '',
        cur_employer: '', // Map current employer if available
        curriculum_board: '',
        fun_area: '',
        professional_start_date: null,
        professional_end_date: null,
        currently_working: false,
        notice_period: '',
        // resume: '',
        certificate: null,
        cover_letter: null,
        pipeline_stage: '',
        pipeline_stage_status: '',
        user_experiences: selectedResume.employmentHistory || [],
        user_educations: selectedResume.educationHistory || [],
        headline: null,
        summary: selectedResume.professionalSummary || '',
      };
      localStorage.setItem("formdata",JSON.stringify(formData))
      // Send formData to the API
      const apiResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/candidate/candidates-without-login/`, formData);
      // console.log('Application submitted successfully:', apiResponse.data);
      toast.success("Application submitted successfully!");
      fetchJobApplications();
    } catch (error) {
      console.error('Error submitting application:', error);
    }
    setIsModalOpen(false);
  };

  const columns = [
    {
      name: 'Action',
      cell: row => (
        <div>
          <button onClick={() => {
            window.location.href = `${process.env.REACT_APP_JOBS_SITE_URL}JobApplication/${row.webform}?jobtitle=${row.title}&jobid=${row.id}&user=${user.email}&assesment=${row.assesment}`;
            }} 
            className="applyButton">
            Apply
          </button>
          <button 
            style={{ backgroundImage: "linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%)" }} 
            onClick={() => {
              setSelectedJobId({ ...row, apply: true });
              setIsModalOpen(true);
            }}
            className="applyButton"
          >
            View
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Title',
      selector: row => row.title,
      sortable: true,
    },
    {
      name: 'Experience',
      selector: row => `${row.Experience} - ${row.Experience_max} years`,
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.type,
      sortable: true,
    },
    // {
    //   name: 'Location',
    //   selector: row => row.location,
    //   sortable: true,
    // },
    {
      name: 'Company',
      selector: row => row.company_name,
      sortable: true,
    },
    {
      name: 'Posted Date',
      selector: row => new Date(row.posted_date).toLocaleDateString(),
      sortable: true,
    },
    {
      name: 'Salary',
      selector: row => `${row.salary_min} - ${row.salary_max}`,
      sortable: true,
    },
  ];

  const jobApplicationColumns = [
    {
      name: 'Action',
      cell: row => (
        <button
          style={{ backgroundImage: "linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%)" }}
          onClick={() => {
            setSelectedJobId({ ...row, apply: false });
            setIsModalOpen(true);
          }}
          className="applyButton"
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Title',
      selector: row => row.dynamic_job_data?.["Create Job"].title || 'N/A',
      sortable: true,
    },
    {
      name: 'Experience',
      selector: row => `${row.dynamic_job_data?.["Create Job"].exp_min || 0} - ${row.dynamic_job_data?.["Create Job"].exp_max || 0} years`,
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.dynamic_job_data?.["Create Job"].type || 'N/A',
      sortable: true,
    },
    // {
    //   name: 'Location',
    //   selector: row => row.dynamic_job_data?.["Create Job"].location.name || 'N/A',
    //   sortable: true,
    // },
    {
      name: 'Company',
      selector: row => row?.company || 'N/A',
      sortable: true,
    },
    {
      name: 'Posted Date',
      selector: row => row.posted_date ? new Date(row.posted_date).toLocaleDateString() : 'N/A',
      sortable: true,
    },
    {
      name: 'Salary',
      selector: row => `${row.dynamic_job_data?.["Create Job"].salary_min || 'N/A'} - ${row.dynamic_job_data?.["Create Job"].salary_max || 'N/A'}`,
      sortable: true,
    },
  ];

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredJobs = jobs.filter(job =>
    (job.title && job.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (job.company_name && job.company_name.toLowerCase().includes(searchTerm.toLowerCase())) 
    // (job.location && job.location.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleJobSearchChange = (event) => {
    setJobSearchTerm(event.target.value);
  };

  const filteredJobApplications = jobApplications.filter(application =>
    (application.title && application.title.toLowerCase().includes(jobSearchTerm.toLowerCase())) ||
    (application.company_name && application.company_name.toLowerCase().includes(jobSearchTerm.toLowerCase()))
    // (application.location && application.location.toLowerCase().includes(jobSearchTerm.toLowerCase()))
  );

  return (
    <>
      {gettingUser ? (
        <img
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          width='240'
          height='240'
          alt='loading...'
          src='https://media2.giphy.com/media/MDrmyLuEV8XFOe7lU6/200w.webp?cid=ecf05e47k6onrtqddz8d98s4j5lhtutlnnegeus1pwcdwkxt&ep=v1_gifs_search&rid=200w.webp&ct=g'
        />
      ) : (
        <>
          <Nav />
          <div className='menuoptions2'>
            <button
              onClick={() => handler()}
              className='btn-success signoutBtn'
            >
              {" "}
              <Power color='#ffffff' size={22} /> &nbsp;Signout
            </button>
            <button
              className='custom-btnlanding btn-2'
              style={{
                "z-index": "45",
                top: "12px",
                right: "20%",
                cursor: "none",
                fontFamily: "Open Sans",
                textAlign: "left",
                color: "#ffffff",
                backgroundColor: "rgb(50 83 165)",
                fontWeight: "550",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <DatabaseFill
                color='#ffffff'
                size={22}
                style={{ position: "relative", top: "-2px" }}
              />
              {"  "}
              &nbsp;{user.credits}
              {"  "}
              <button
                onClick={() => navigate("/upgrade")}
                className='custom-btnlanding custom-btnlanding-hover'
                style={{
                  width: "100px",
                  "z-index": "45",
                  top: "0%",
                  right: "0%",
                  fontFamily: "Open Sans",
                  textAlign: "center",
                  color: "#ffffff",
                  backgroundImage: 'linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%)',
                  fontWeight: "550",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  paddingTop: "1px",
                  paddingBottom: "1px",
                  height: "32px",
                  marginTop: "4px",
                  fontSize: "12px",
                  marginRight: "10px",
                  border: "none",
                }}
              >
                Upgrade
              </button>
            </button>
          </div>
          <button className='menubtn menuBtnDash' onClick={handleMenu}>
            <List color='#35b276' size={22} />
          </button>

          {showMenu && (
            <div className='menuoptions'>
              <button
                className='custom-btn btn-2'
                style={{
                  // "z-index": "45",
                  // top: "25%",
                  // right: "13%",
                  cursor: "none",
                  fontFamily: "Open Sans",
                  textAlign: "left",
                  color: "#ecf8e5",
                  backgroundColor: "#347571",
                  fontWeight: "550",
                  display: "flex",
                  alignItems: "center",
                  // gap: "5px",
                  justifyContent: "space-between",
                }}
              >
                {" "}
                <DatabaseFill
                  color='#ecf8e5'
                  size={22}
                  style={{ position: "relative", top: "-2px" }}
                />{" "}
                &nbsp;{user.credits}{" "}
                <button
                  onClick={() => toast.info("Coming Soon !")}
                  className='custom-btn'
                  style={{
                    width: "100px",
                    "z-index": "45",
                    top: "0%",
                    right: "0%",
                    fontFamily: "Open Sans",
                    textAlign: "center",
                    color: "#347571",
                    backgroundColor: "#ecf8e5",
                    fontWeight: "550",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    paddingTop: "1px",
                    paddingBottom: "1px",
                    height: "32px",
                    //   marginTop: "4px",
                    fontSize: "12px",
                    //   marginRight: "10px",
                    border: "none",
                  }}
                >
                  Upgrade
                </button>{" "}
              </button>
              <button
                onClick={() => handler()}
                className=' btn btn-success signoutBtn createLiveSignOut'
                style={{ marginTop : '0px' }}
              >
                <Power color='#ffffff' size={22} /> &nbsp;Signout
              </button>
            </div>
          )}
          
          {/* <button
            className='tokensBtn'
            style={{
              fontFamily: "Open Sans",
              fontWeight: "550",
              fontSize: "16px",
              color: "#347571",
            }}
          >
            <DatabaseFill
              color='#347571'
              size={24}
              style={{ position: "relative", top: "-2px" }}
            />{" "}
            &nbsp;{user.credits} Credits
          </button> */}

          <div className='dashboardDiv'>
            <h2 className='formTitle'>Resume Gallery</h2>
            <p className='formSubText'>
              "Welcome to your hub for organized resumes.Access, edit, or create
              new resumes for tailored job application."
            </p>
            <div className='dashHeader'>
              <h4>Documents</h4>
              <button
                className='createDoc zoom'
                onClick={() => navigate("/create")}
              >
                <PlusLg size={20} /> &nbsp;Create New
              </button>

                <button
                className='uploadDoc zoom'
                onClick={() => navigate("/create", { state: { upload: true } })}
                data-tooltip-id='uploadNewResumeInfo'
                data-tooltip-content='This will cost 4 credits'
              >
                <Upload size={20} /> &nbsp;Upload Resume
              </button>
              <Tooltip id='uploadNewResumeInfo' />
            </div>
            <hr className='dashHrLine' />
            {isPopupOpen && (
              <JobPopup onClose={togglePopup} onSignup={handleSignup} />
            )}
            <div className='dashContent row'>
              {savedResumes.map((savedResume) => (
                <div key={savedResume.id} className='resume1Div col-md-6'>
                  <div className='row'>
                    <div
                      className='col-md-4'
                      onClick={() => openSelectedResume(savedResume.idx)}
                    >
                      <img
                        src={savedResume.img}
                        className='resumeImg zoom'
                        alt='Profile Image'
                      />
                      <h6 className='resumeTitle'>{savedResume.title}</h6>
                    </div>
                    <div className='col-md-8 editResumeOptions'>
                      <button
                        className='editResumeBtns '
                        onClick={() => tailor(savedResume.idx)}
                      >
                        <Bullseye size={23} />
                        &nbsp;&nbsp;&nbsp;&nbsp;Tailor To Your Job
                      </button>
                      <br />
                      <button
                        className='editResumeBtns '
                        onClick={() => openSelectedResume(savedResume.idx)}
                      >
                        <PencilFill size={23} />
                        &nbsp;&nbsp;&nbsp;&nbsp;Edit
                      </button>
                      <br />
                      <button
                        className='editResumeBtns '
                        onClick={() => download(savedResume.idx)}
                      >
                        <FileEarmarkArrowDownFill size={23} />
                        &nbsp;&nbsp;&nbsp;&nbsp;Download
                      </button>
                      <br />
                      <button
                        className='editResumeBtns '
                        onClick={() => delSavedResume(savedResume.id)}
                      >
                       
                        <Trash3Fill size={23} />
                        {deleting ? (
                          <>&nbsp;&nbsp;&nbsp;&nbsp;Deleting ...</>
                        ) : (
                          <>&nbsp;&nbsp;&nbsp;&nbsp;Delete</>
                        )}
                      </button>
                      <br />
                      {/* <button className='editResumeBtns ' onClick={() => console.log("more")}><ThreeDots size={23} />&nbsp;&nbsp;&nbsp;&nbsp;More</button><br /> */}
                    </div>
                    <p className='resumeDesc'>
                      <strong>Created At : </strong>
                      {savedResume.description}
                    </p>
                  </div>
                </div>
              ))}
              <div className='resume1Div col-md-6  '>
                <div className='addNewResumeDiv zoom' onClick={addSavedResume}>
                  <button className='editResumeBtns addResumePlusBtn'>
                    <PlusLg size={35} />
                    <br />
                  </button>
                  <p>Add New</p>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '10px' }}>
              <h2 className='formTitle' >Apply Job List</h2>
                <input
                  type="text"
                  placeholder="Search job applications..."
                  value={jobSearchTerm}
                  onChange={handleJobSearchChange}
                  style={{ marginBottom: '20px', padding: '10px', width: '100%' }}
                />
                <DataTable
                  columns={jobApplicationColumns}
                  data={filteredJobApplications}
                  pagination
                  responsive
                  highlightOnHover
                  striped
                  customStyles={{
                    headRow: {
                      style: {
                        backgroundColor: '#17213a',
                        color: '#ffffff'
                      }
                    }
                  }}
                />
            </div>
            <div style={{ marginTop: '10px' }}>
              <h2 className='formTitle'>Job Listings</h2>
                <input
                type="text"
                placeholder="Search jobs..."
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ marginBottom: '20px', padding: '10px', width: '100%' }}
              />
                <DataTable
                  columns={columns}
                  data={filteredJobs}
                  pagination
                  responsive
                  highlightOnHover
                  striped
                  customStyles={{
                    headRow: {
                      style: {
                        backgroundColor: '#17213a',
                        color: '#ffffff'
                      }
                    }
                  }}
                />
            </div>
          </div>
        </>
      )}
      {/* {isModalOpen && (
        <ResumeSelectorModal
          resumes={savedResumes}
          onSelect={handleResumeSelect}
          onClose={() => setIsModalOpen(false)}
        />
      )} */}

      {isModalOpen && (
          <ViewJob
            job={selectedJobId}
            onClose={() => setIsModalOpen(false)}
            userEmail = {user.email}
          />
      )}
    </>
  );
}
